import GatewayBase from './gateway-base';

export default class PostmarkRestService extends GatewayBase {
  getSenderSignature(email: string) {
    return this.client.get(`/v1/postmark/sender-signature/${email}`);
  }

  createSenderSignature(senderData: { senderFromEmail: string; senderFromName: string; senderReplyTo: string }) {
    return this.client.post('/v1/postmark/sender-signature', senderData);
  }

  createDomain(domain: string) {
    return this.client.post('/v1/postmark/domain', { domain });
  }

  getDomain(domain: string) {
    return this.client.get(`/v1/postmark/domain/${domain}`);
  }

  verifyDkim(domain: string) {
    return this.client.put(`/v1/postmark/domain/${domain}/verify-dkim`);
  }

  verifyReturnPath(domain: string) {
    return this.client.put(`/v1/postmark/domain/${domain}/verify-return-path`);
  }

  sendEmail(data: { to: string; subject: string; html: string; from?: string }) {
    return this.client.post('/v1/postmark/send-email', data);
  }

  saveSenderSignature(data: {
    storeId: string;
    domainData: {
      dkimVerified: boolean;
      returnPathVerified: boolean;
    };
    signatureEmail?: string;
    senderFromName?: string;
    senderReplyTo?: string;
  }) {
    return this.client.post('/v1/postmark/save-sender-signature', data);
  }
}
